import gql from 'graphql-tag';

export const ITEMS_QUERY = gql`
  query GetItems($venueId: ID!) {
    venue: Venue(id: $venueId) {
      id
      name
      location {
        id
        name
        city
        street
        zip
      }
      organizationId
      company {
        id
        name
        country
        defaultLanguage
        items {
          id
          title
          defaultPrice
          inventoryEOD
        }
        categories {
          id
          parentId
          nameLang {
            id
            en
            es
            se
            no
          }
        }
        staffs {
          id
          name
        }
      }
      cashSources {
        id
        name
      }
    }
  }
`;

export const ALL_CASH_EVENTS_QUERY = gql`
  query GetAllCashEvents(
    $filter: POSDeviceWhereInput
    $sentAfter: DateTime!
    $sentBefore: DateTime
    $venueId: String
  ) {
    allPOSDevices(filter: $filter) {
      id
      cashEvents {
        events(sentAfter: $sentAfter, sentBefore: $sentBefore, venueId: $venueId) {
          items
          lastKey
        }
      }
    }
  }
`;

export const TABLE_EVENTS_SNAPSHOTS_QUERY = gql`
  query GetVenueTableEventsSnapshots($venueId: ID!, $date: DateTime!) {
    Venue(id: $venueId) {
      id
      eventsSnapshot(date: $date)
    }
  }
`;
